export const SUBMIT_TOKEN = "SUBMIT_TOKEN";